import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import type { BlockerFunction } from 'react-router-dom';

interface BlockerPromptProps {
  children: React.ReactNode;
  shouldBlock?: boolean;
  message?: string;
}

export function BlockerPrompt({
  children,
  shouldBlock = false,
  message = 'Are you sure you want to leave? Your changes may be lost.',
}: BlockerPromptProps) {
  // Always call the hook, but pass a function that checks shouldBlock
  const blockerFn: BlockerFunction = ({ currentLocation, nextLocation }) => {
    // If locations are different, we need to block
    return currentLocation.pathname !== nextLocation.pathname;
  };

  const blocker = useBlocker(shouldBlock ? blockerFn : false);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const shouldProceed = window.confirm(message);
      if (shouldProceed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  return children;
}
